// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"74":"About","384":"workstudyplus-parent"}[chunkId] || chunkId) + "." + {"74":"64133be3","384":"ec699795","552":"4e68c87e","761":"66e8b699","889":"af75fa17"}[chunkId] + ".css";
};